import type { ReactNode } from "react";
import React from "react";
import { accordionContent, accordionContentExpanded } from "./Accordion.css";

export type AccordionItemContentProps = {
  value?: string;
  selectedValue?: string | null;
  expandAll?: boolean;
  children: ReactNode;
};

export const AccordionItemContent: React.FC<AccordionItemContentProps> = ({
  value,
  selectedValue,
  expandAll,
  children
}) => {
  const isSelected = expandAll || selectedValue === value;
  return (
    <div
      className={`${accordionContent} ${
        isSelected ? accordionContentExpanded : ""
      }`}
      role="region"
    >
      {children}
    </div>
  );
};
